import { render } from "./SubmissionHeader.vue?vue&type=template&id=fba5cba2&lang=true"
import script from "./SubmissionHeader.vue?vue&type=script&lang=js"
export * from "./SubmissionHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__